import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SelectRespondentService {

  isConfirmPanelSource: BehaviorSubject<boolean> = new BehaviorSubject(false);

  isDistributeYourself: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() { }
}
